import { IconClose } from "@/assets/icons";
import { IconBox } from "@/components/elements/IconBox";
import { background, black } from "@/theme/colors";
import { Box, Modal as MuiModal, Stack, styled } from "@mui/material";
import { FC } from "react";

export type TPreviewModalProps = {
  isOpen: boolean;
  onClose?: () => void;
  url?: string;
};

export const PreviewModal: FC<TPreviewModalProps> = ({ isOpen, onClose, url }) => {
  return (
    <MuiModal open={isOpen} onClose={onClose} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <ModalContainer>
        <Stack direction="row" alignItems="center" justifyContent="flex-end">
          <IconBox onClick={onClose} sx={{ p: 0 }}>
            <IconClose color={black[80]} fontSize={24} />
          </IconBox>
        </Stack>
        <img src={url} width="100%" height="100%" style={{ objectFit: "cover", padding: "8px 16px", maxWidth: "70vw", maxHeight: "70vh" }} />
      </ModalContainer>
    </MuiModal>
  );
};

const ModalContainer = styled(Box)`
  min-width: 417px;
  background-color: ${background.white};
  box-shadow: 0px 8px 24px 0px #00000026;
  border-radius: 8px;
  padding: 16px;
  max-height: 90vh;
  outline: none; /* Remove default focus outline */
  &:focus {
    outline: none;
  }
`;
